const calculatePropertiesForPencil = (settings) => {
  const properties = {};

  properties.subtraction = settings.useAsRag;

  properties.textures = {
    paintTexture: 'splatPencilPaintTexture',
    paintTempTexture: 'splatPencilPaintTempTexture',
    divergenceTexture: 'splatPencilDivergenceTexture',
    pressureTexture: 'splatPencilPressureTexture',
    pressureTempTexture: 'splatPencilPressureTempTexture',
    velocityTexture: 'splatPencilVelocityTexture',
    velocityTempTexture: 'splatPencilVelocityTempTexture',
  };

  properties.removeBrushByPencil = false;
  properties.sampleToGetMedium = false;
  properties.samplePencilTexture = false;

  properties.splatRadius = settings.splatRadius * settings.brushScale;

  properties.zThreshold = settings.brushZThreshold * settings.brushScale;

  properties.fluidity = settings.primary.fluidity;

  properties.deltaTime = 1.0 / settings.primary.deltaTimeDivider;

  let medium, height;

  if (properties.subtraction) {
    height = 0.0;
    medium = 1.0;
  } else {
    height = settings.medium;
    medium = 1.0 - settings.medium;
  }

  const minNS = settings.minimalNormalScale;

  const mediumCoeff = Math.pow(height, 0.3);
  const normalScale = settings.normalScale / 100;
  let normals = 1 - (minNS + (255 - minNS) * mediumCoeff) / 255;
  normals = normalScale * normals;

  properties.color = [0.0, normals, medium, undefined];

  // brush cleans pencil trace on pencil texture
  if (settings.useAsBrush) {
    properties.fluidity = settings.secondary.fluidity;
    properties.deltaTime = 1.0 / settings.secondary.deltaTimeDivider;
  }

  if (settings.useAsPencil) {
    properties.sampleToGetMedium = true;
    properties.samplePencilTexture = true;
  }

  properties.splatVelocityScale = settings.splatVelocityScale;
  properties.medium = settings.medium;

  // testing
  properties.alpha = settings.global.alpha;
  properties.useGlobalAlpha = settings.global.useGlobalAlpha;
  properties.force = settings.force;
  properties.getForceFromPen = settings.getForceFromPen;

  return properties;
};

export default calculatePropertiesForPencil;
